import React, {useEffect, useState, useRef} from 'react';
import PropTypes from 'prop-types';
import {Link} from 'react-router-dom';
import AliceCarousel from 'react-alice-carousel';
import '../../assets/styles/react-alice-carousel.scss';
import _find from 'lodash/find';
import _cloneDeep from 'lodash/cloneDeep';
import propertyWriter from '../../lib/urlWriters/webURL';
import {trackSelectItem} from '../../lib/tracking';
import '../../lib/lazysizes';
import styles from './Carousel.scss';
import {getPropertyImages} from '../../lib/ImagesUtil';

const Slide = (props) => {
  const imageURL = `${props.imageURL}${(props.imageURL.indexOf('?') == -1) ? '?' : '&'}width=600`;
  return (<div className={`${styles.cardCarouselSlide} ${props.hasImage ? '' : styles.cardCarouselPlaceholder} lazyload`} data-bg={imageURL} />);
}

function CardCarousel(props) {
  const Carousel = useRef();
  const [slides, setSlides] = useState([]);
  const [showButtons, setShowButtons] = useState([]);
  const [currentIndex, setCurrentIndex] = useState(0);
  const [cardImages, setCardImages] = useState([]);
  const [url, setURL] = useState('/');
  let mainImage = _find(props?.property?.links, {'rel': 'mainImage'});

  const initialiseSlides = () => {
    const isOffMarketOrSoldProperty = props.property.recentlySold === false
      || (props.property.recentlySold === true && props.property.isSoldListing === false);

    const happyHouse = '/assets/images/icon_happy.svg';

    if (props.property) {
      if (cardImages && cardImages.length > 1 && !props.mapCard) {
        let maxLen = cardImages.length;
        let newSlides = [...Array(maxLen)];
        newSlides[0] = <Slide imageURL={cardImages[0].url} />
        newSlides[1] = <Slide imageURL={cardImages[1].url} />
        newSlides[maxLen-1] = <Slide imageURL={cardImages[maxLen-1].url} />
        setSlides(newSlides);
        setShowButtons(true);
      } else {
        let imageURL = happyHouse;
        const hasImage = _find(props.property.links, { rel: 'mainImage' });
        if (hasImage?.href) imageURL = hasImage.href;
        setSlides([<Slide imageURL={imageURL} hasImage={hasImage}/>]);
        setShowButtons(false);
      }
    }
  }
  const getNextSlide = (slideInfo) => {
    if (cardImages.length > 0) {
      let maxIndex = cardImages.length - 1;
      let nextItem = (slideInfo.item == maxIndex) ? 0 : slideInfo.item + 1;
      let prevItem = (slideInfo.item == 0) ? maxIndex : slideInfo.item - 1;
      let newslides = _cloneDeep(slides);
      if (slides[nextItem] === undefined) {
        newslides[nextItem] = <Slide imageURL={cardImages[nextItem].url} />;
      }
      if (slides[prevItem] === undefined) {
        newslides[prevItem] = <Slide imageURL={cardImages[prevItem].url} />;
      }
      setCurrentIndex(slideInfo.item);
      setSlides(newslides);
    }
  }

  const trackClick = () => trackSelectItem(props?.property);

  useEffect(() => {
    initialiseSlides();
  }, []);

  useEffect(() => {
    setURL(propertyWriter(props.property));
    if (!props.property?.imageList && cardImages.length === 0 && props.fetchImages) getPropertyImages(props.property, props.mapCard).then((resp) => setCardImages(resp));
    if (!mainImage) mainImage = _find(props?.property?.links, {'rel': 'mainImage'});
    if (props.property?.imageList && cardImages.length === 0) {
      initialiseSlides();
      setCardImages(props.property.imageList);
    }
  }, [props.property]);

  useEffect(() => {
    initialiseSlides();
  }, [cardImages]);

  return (
    <div className={styles.cardCarousel}>
      <Link onClick={trackClick} to={url}>
        {mainImage?.href ? <img data="seoData" src={mainImage.href} alt={props.property?.address?.formattedAddress} width="300" /> : null}
        {slides.length &&
        <AliceCarousel
          keysControlDisabled={true}
          ref={Carousel}
          activeIndex={currentIndex}
          onSlideChanged={getNextSlide}
          disableSlideInfo={true}
          mouseTracking={true}
          touchTracking={true}
          items={slides}
          animationType="fadeout"
          infinite={true}
          touchMoveDefaultEvents={false}
          swipeDelta={5}
          disableDotsControls={true}
          disableButtonsControls={true} />}
      </Link>
      {showButtons ?
        <div>
          <div className={styles.leftButton} onClick={() => Carousel.current.slidePrev()}></div>
          <div className={styles.rightButton} onClick={() => Carousel.current.slideNext()}></div>
        </div>
      : null}
    </div>
  );
}

CardCarousel.propTypes = {
  property: PropTypes.object.isRequired,
  fetchImages: PropTypes.bool,
  mapCard: PropTypes.bool,
};

export default CardCarousel;
